import ApiService from "@/common/api/api.service";

let endpoint = "ProjetoGestao";

const ComprovanteHH = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvar(form) {
        if(form.id)
            return ApiService.put(`${endpoint}/comprovante-hh`, form)
        else
            return ApiService.post(`${endpoint}/comprovante-hh`, form)
            
    },

    listar(equipeId) {
        return ApiService.get(`${endpoint}/comprovante-hh?recursoHumanoId=${equipeId}`);
    },

    buscar(id) {
        return ApiService.get(`${endpoint}/comprovante-hh?id=${id}`);
    },

    deletar(id) {
        let form = {
            id: id
        }
        return ApiService.delete(`${endpoint}/comprovante-hh`, form);
    },

    downloadComprovanteHH(arquivoId) {
        return ApiService.downloadFile(`${endpoint}/comprovante-hh/download-arquivo?id=${arquivoId}`)
    },
}

export default ComprovanteHH;
